export default "__VITE_ASSET__sDqQYjov__"